"use client";
import {
  ProviderContext
} from "./chunk-Q66YAGZJ.mjs";

// src/provider.tsx
import { I18nProvider } from "@react-aria/i18n";
import { RouterProvider } from "@react-aria/utils";
import { OverlayProvider } from "@react-aria/overlays";
import { useMemo } from "react";
import { CalendarDate } from "@internationalized/date";
import { jsx } from "react/jsx-runtime";
var NextUIProvider = ({
  children,
  navigate,
  locale = "en-US",
  defaultDates = {
    minDate: new CalendarDate(1900, 1, 1),
    maxDate: new CalendarDate(2099, 12, 31)
  },
  createCalendar,
  ...otherProps
}) => {
  let contents = children;
  if (navigate) {
    contents = /* @__PURE__ */ jsx(RouterProvider, { navigate, children: contents });
  }
  const context = useMemo(
    () => ({ createCalendar, defaultDates }),
    [createCalendar, defaultDates == null ? void 0 : defaultDates.maxDate, defaultDates == null ? void 0 : defaultDates.minDate]
  );
  return /* @__PURE__ */ jsx(ProviderContext, { value: context, children: /* @__PURE__ */ jsx(I18nProvider, { locale, children: /* @__PURE__ */ jsx(OverlayProvider, { ...otherProps, children: contents }) }) });
};

export {
  NextUIProvider
};
